// @flow
import * as React from 'react';
import { Form, Input, InputNumber, Select, Switch, Checkbox } from 'antd';
import { connect } from 'react-redux';
import { setFormValue } from '../State/form';

const { TextArea } = Input;
const { Option, OptGroup } = Select;

type Props = {
  form: {},
  supplierItem: {},
  setFormValue: (key: string, value: any) => void,
}

class SupplierItemForm extends React.PureComponent<Props> {

  render() {
    const { form, supplierItem, setFormValue } = this.props;

    return (
      <Form layout="vertical">

        <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 16 }}>
          <Form.Item label="Item Name" required>
            <Input
              value={form.name}
              onChange={(e) => setFormValue('name', e.target.value)}
              placeholder="Enter item name"
            />
          </Form.Item>

          <Form.Item label="Item Code / SKU">
            <Input
              value={form.item_code}
              onChange={(e) => setFormValue('item_code', e.target.value)}
              placeholder="Supplier's code"
            />
          </Form.Item>
        </div>

        <Form.Item label="Description">
          <TextArea
            value={form.description}
            onChange={(e) => setFormValue('description', e.target.value)}
            placeholder="Detailed description"
            rows={3}
          />
        </Form.Item>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <Form.Item label="Category">
            <Select
              value={form.category}
              onChange={(value) => setFormValue('category', value)}
              placeholder="Select category"
              showSearch
              allowClear
            >
              <OptGroup label="Materials">
                <Option value="Paint & Coatings">Paint & Coatings</Option>
                <Option value="Plumbing Materials">Plumbing Materials</Option>
                <Option value="Electrical Materials">Electrical Materials</Option>
                <Option value="Timber & Joinery">Timber & Joinery</Option>
                <Option value="Bricks & Blocks">Bricks & Blocks</Option>
                <Option value="Cement & Aggregates">Cement & Aggregates</Option>
                <Option value="Roofing Materials">Roofing Materials</Option>
                <Option value="Insulation">Insulation</Option>
                <Option value="Flooring Materials">Flooring Materials</Option>
                <Option value="Tiles & Ceramics">Tiles & Ceramics</Option>
                <Option value="Ironmongery">Ironmongery (Hardware)</Option>
                <Option value="Glass & Glazing">Glass & Glazing</Option>
                <Option value="Drywall & Plaster">Drywall & Plaster</Option>
                <Option value="Adhesives & Sealants">Adhesives & Sealants</Option>
              </OptGroup>
              <OptGroup label="Equipment Hire">
                <Option value="Plant Hire">Plant Hire (Excavators, Dumpers)</Option>
                <Option value="Access Equipment">Access Equipment (Scaffolding, Towers, Lifts)</Option>
                <Option value="Power Tools">Power Tools</Option>
                <Option value="Hand Tools">Hand Tools</Option>
                <Option value="Temporary Works Equipment">Temporary Works Equipment</Option>
                <Option value="Site Accommodation">Site Accommodation (Cabins, Toilets)</Option>
              </OptGroup>
              <OptGroup label="Services">
                <Option value="Subcontractor Labour">Subcontractor Labour</Option>
                <Option value="Professional Services">Professional Services (Surveying, Testing)</Option>
                <Option value="Waste Disposal">Waste Disposal</Option>
                <Option value="Site Security">Site Security</Option>
                <Option value="Cleaning Services">Cleaning Services</Option>
              </OptGroup>
              <OptGroup label="Consumables">
                <Option value="PPE">PPE (Personal Protective Equipment)</Option>
                <Option value="Site Consumables">Site Consumables (Fuel, Cleaning)</Option>
                <Option value="Office Supplies">Office Supplies</Option>
              </OptGroup>
            </Select>
          </Form.Item>

          <Form.Item label="Unit of Measure" required>
            <Select
              value={form.unit_of_measure}
              onChange={(value) => setFormValue('unit_of_measure', value)}
              placeholder="Select unit"
            >
              <Option value="each">Each</Option>
              <Option value="m">Metres (m)</Option>
              <Option value="m²">Square Metres (m²)</Option>
              <Option value="m³">Cubic Metres (m³)</Option>
              <Option value="kg">Kilograms (kg)</Option>
              <Option value="tonne">Tonnes</Option>
              <Option value="litre">Litres</Option>
              <Option value="hour">Hours</Option>
              <Option value="day">Days</Option>
              <Option value="week">Weeks</Option>
              <Option value="box">Box</Option>
              <Option value="pack">Pack</Option>
              <Option value="bag">Bag</Option>
            </Select>
          </Form.Item>
        </div>

        <Form.Item label="Manufacturer">
          <Input
            value={form.manufacturer}
            onChange={(e) => setFormValue('manufacturer', e.target.value)}
            placeholder="e.g. Dulux, Crown, Johnstone's"
          />
        </Form.Item>

        {form.category === 'Paint & Coatings' && (
          <div style={{ background: '#f6f8fa', border: '1px solid #e8ecef', borderRadius: 6, padding: '12px 16px', marginBottom: 16 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
              <div style={{ fontWeight: 500, color: '#555' }}>Paint Details</div>
              <Checkbox
                checked={form.add_to_paint_list}
                onChange={(e) => setFormValue('add_to_paint_list', e.target.checked)}
              >
                Add to Paint List
              </Checkbox>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
              <Form.Item label="Number of Coats" style={{ marginBottom: 0 }}>
                <InputNumber
                  value={form.paint_coats}
                  onChange={(value) => setFormValue('paint_coats', value)}
                  placeholder="e.g. 2"
                  min={1}
                  step={1}
                  precision={0}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item label="Coverage per Litre (m²/L)" style={{ marginBottom: 0 }}>
                <InputNumber
                  value={form.paint_coverage_per_litre}
                  onChange={(value) => setFormValue('paint_coverage_per_litre', value)}
                  placeholder="e.g. 12.5"
                  min={0}
                  step={0.01}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item label="Carbon per Litre (kg CO₂/L)" style={{ marginBottom: 0 }}>
                <InputNumber
                  value={form.paint_carbon_per_litre}
                  onChange={(value) => setFormValue('paint_carbon_per_litre', value)}
                  placeholder="e.g. 1.8"
                  min={0}
                  step={0.001}
                  style={{ width: '100%' }}
                />
              </Form.Item>
            </div>
          </div>
        )}

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 16 }}>
          <Form.Item label="Unit Price" required>
            <InputNumber
              value={form.unit_price}
              onChange={(value) => setFormValue('unit_price', value)}
              placeholder="0.00"
              min={0}
              step={0.01}
              style={{ width: '100%' }}
              formatter={value => `£ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              parser={value => value.replace(/£\s?|(,*)/g, '')}
            />
          </Form.Item>

          <Form.Item label="Currency">
            <Select
              value={form.currency}
              onChange={(value) => setFormValue('currency', value)}
            >
              <Option value="GBP">GBP (£)</Option>
              <Option value="EUR">EUR (€)</Option>
              <Option value="USD">USD ($)</Option>
            </Select>
          </Form.Item>

          <Form.Item label="VAT Rate (%)">
            <Select
              value={form.tax_rate !== undefined && form.tax_rate !== null ? parseInt(form.tax_rate) : 20}
              onChange={(value) => setFormValue('tax_rate', value)}
              style={{ width: '100%' }}
            >
              <Option value={0}>0%</Option>
              <Option value={20}>20%</Option>
            </Select>
          </Form.Item>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
          <Form.Item label="Lead Time (Days)">
            <InputNumber
              value={form.lead_time_days}
              onChange={(value) => setFormValue('lead_time_days', value)}
              placeholder="Lead time in days"
              min={0}
              style={{ width: '100%' }}
            />
          </Form.Item>

          <Form.Item label="Minimum Order Quantity">
            <InputNumber
              value={form.minimum_order_quantity}
              onChange={(value) => setFormValue('minimum_order_quantity', value)}
              placeholder="Min order qty"
              min={0}
              step={0.01}
              style={{ width: '100%' }}
            />
          </Form.Item>
        </div>

        {supplierItem && form.unit_price !== null && (
          <Form.Item label="Reason for Price Change" help="Optional - explain why the price is changing">
            <Input
              value={form.cost_change_reason}
              onChange={(e) => setFormValue('cost_change_reason', e.target.value)}
              placeholder="e.g., Supplier price increase, Bulk discount"
            />
          </Form.Item>
        )}

        <Form.Item label="Notes">
          <TextArea
            value={form.notes}
            onChange={(e) => setFormValue('notes', e.target.value)}
            placeholder="Additional notes about this item"
            rows={3}
          />
        </Form.Item>

        <Form.Item label="Active">
          <Switch
            checked={form.active}
            onChange={(checked) => setFormValue('active', checked)}
          />
        </Form.Item>

      </Form>
    );
  }
}

const mapStateToProps = (state) => ({
  form: state.modals.SupplierItem.form,
  supplierItem: state.modals.SupplierItem.supplierItem,
});

const actionCreators = {
  setFormValue,
};

export default connect(mapStateToProps, actionCreators)(SupplierItemForm);
